@if (isInternalLink) {
  <a [routerLink]="link ?? '/projects'" class="logo-link p-1" title="Home">
    <img class="logo" [src]="logoUrl">
  </a>
}
@if (!isInternalLink) {
  <a [href]="link" class="logo-link p-1">
    <img class="logo" [src]="logoUrl">
  </a>
}